import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { getMediaPath, reactParserCommonOptions } from '../../app/functions';
import HeaderGallery from 'pages/customer-join/sections/HeaderGallery';

const ContentSection = ({ section }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [text, setText] = useState('');

  useEffect(() => {
    if (section.text_mobile && isMobile) {
      setText(section.mobileText);
    } else if (section.text && !isMobile) {
      setText(section.text);
    } else {
      setText(section.text);
    }
  }, [section]);

  if (!section) return null;
  const history = useHistory();

  const isDeepLink = (link) => {
    return link.linkType === 'deeplink';
  }
  
  const isExternalLink = (link) => {
    return link.linkType === 'external';
  }
  
  const processBannerLink = (bannerLink) => {
    if (!bannerLink) return '#';

    if (isDeepLink(bannerLink)) {
      return bannerLink.link;
    }
    if (isExternalLink(bannerLink)) {
      return bannerLink.link;
    }
    
    if (bannerLink.link.startsWith('http') || bannerLink.link.startsWith('https')) {
      try {
        const url = new URL(bannerLink.link);
        return url.pathname;
      } catch (e) {
        console.error('Invalid URL:', bannerLink.link);
        return '#';
      }
    }
    
    return bannerLink.link;
  };

  return (
    <Box key={section.id}>
      {section.desktop_banner && section.mobile_banner && (
        <HeaderGallery 
          data={{
            galleryDesktop: [{
              id: 0, 
              imagePath: getMediaPath(section.desktop_banner), 
              link: section.link,
              linkType: section?.linkType
            }],
            galleryMobile: [{
              id: 0, 
              imagePath: getMediaPath(section.mobile_banner), 
              link: section.link,
              linkType: section?.linkType
            }]
          }} 
          testID="header-gallery-section" 
          aspectRatioDesktop={2560/500}
          aspectRatioMobile={500/400}
          onSlideClick={(slide) => {
            if (slide.link) {
              if (isExternalLink(slide) || isDeepLink(slide)) {
                window.open(slide.link, '_blank');
                return;
              }
              const processedLink = processBannerLink(slide);
              if (processedLink !== '#') {
                history.push(processedLink);
              }
            }
          }}
        />
      )}
      {section.text && (
        <Typography sx={{textAlign: 'center'}} gutterBottom>
          {ReactHtmlParser(text, reactParserCommonOptions())}
        </Typography>
      )}
    </Box>
  );
};

export default ContentSection;
